module.exports = __webpack_public_path__ + "img/logo-rte_old2.f133c8a2.png";